import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireSession } from '@/lib/route-guards';

// /profile/me → /members/{viewerId}. The viewer's own public profile lives
// under /members/{id}; this is a convenience redirect. The parent `_authed`
// gate guarantees a session by the time this `beforeLoad` runs.
export const Route = createFileRoute('/_authed/profile/me')({
  beforeLoad: async ({ context }) => {
    const ctx = await requireSession(context);
    throw redirect({ to: '/members/$id', params: { id: ctx.member.id } });
  },
});
